<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-img eager :src="require('../../../assets/our_service/lead-service2.jpg')" style="border-radius: 4px;"></v-img>
    <v-row class="my-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">{{$t('our-service.startup')}}</span>
      </v-col>
    </v-row>
    <v-layout column>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-00.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="sub-header2 text-tcdc-grey1 d-flex align-center">
            {{$t('our-service.startup-content')}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-01.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Programs</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.startup-detail.programs')}}
                <ul>
                  <li>Seminars</li>
                  <li>Talks</li>
                  <li>Workshops</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-02.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Creative Space</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.startup-detail.creative-space')}}
                <ul>
                  <li>Creative Community Space</li>
                  <li>Template & Toolkit</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-03.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Creative Business Service</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.startup-detail.creative-business')}}
                <ul>
                  <li>Business and Design Consultation</li>
                  <li>Business Matching</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-04.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Resource Center</div>
              <div class="text-tcdc-grey1">
                TCDC Resource Center - {{$t('our-service.startup-detail.resource-center')}}
                <ul>
                  <li>WGSN {{$t('our-service.startup-detail.resource-center-1')}}</li>
                  <li>GMID {{$t('our-service.startup-detail.resource-center-2')}}</li>
                  <li>STASH {{$t('our-service.startup-detail.resource-center-3')}}</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-05.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Maker Space</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.startup-detail.maker-space')}}
                <ul>
                  <li>Rapid Prototype Production</li>
                  <li>Product Development Consultation</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                eager
                :src="require('../../../assets/our_service/service2-06.png')"
                contain
                :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Material & Design Innovation Center</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.startup-detail.material-design')}}
                <ul>
                  <li>Innovation Matching</li>
                  <li>Trend Corner</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GreenButton from "../../../components/buttons/GreenButton";
import { BreadcrumbUtil } from "../../../util/BreadcrumbUtil";
import { mapState } from "vuex";

export default {
  components: {
    // GreenButton
  },
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
              this.items,
              this.branchId,
              this.branchName,
              this.allBranches,
              this.lang
      )
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "OUR SERVICE",
        to: '/our-service'
      },
      {
        text: "BUSINESS STARTUP",
        disabled: true
      }
    ]
  })
};
</script>

<style scoped lang="scss">
  .txt-link {
    cursor: pointer;
  }
  .txt-link:hover {
    color: #2e8037;
  }
</style>
